<template>
    <v-container style="height: 100%">
        <v-row v-if="loading">
            <v-col>
                <v-overlay v-model="loading" opacity="0.8">
                    <v-progress-circular indeterminate size="64" />
                </v-overlay>
            </v-col>
        </v-row>
        <v-row v-if="!loading">
            <v-spacer></v-spacer>
            <v-col :cols="mainCols">
                <div
                    class="
                        text-display-large text-left
                        font-weight-regular
                        text-typography1
                    "
                    style="padding-bottom: 20px"
                >
                    Calculation Browser
                </div>
                <div v-if="!loading" style="align-self: start">
                    <v-card>
                        <v-card-title class="text-typography1">
                            {{ library.name }}
                            <v-btn
                                disabled
                                variant="outlined"
                                size="x-small"
                                v-if="
                                    items.length &&
                                    items[0].libraryVersionStatusId
                                "
                                class="text-capitalize ml-4 px-4"
                            >
                                {{ getLibCategory }}
                            </v-btn>
                        </v-card-title>
                        <v-card-subtitle
                            v-if="items.length && items[0].description"
                            class="text-typography1"
                        >
                            {{ items[0].description }}
                        </v-card-subtitle>
                    </v-card>
                    <Treeview
                        v-if="items.length > 0 && !noCalcsError"
                        :items="items"
                        :firstOpen="open"
                        :url="true"
                        :libraryVersions="allVersions"
                        :firstShow="show"
                        :latest="latest"
                        :calcs="calcs"
                    />
                </div>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
    </v-container>
</template>

<script setup>
import CalcInfo from '../shared/CalcInfo.vue'
import Treeview from '../treeview/Treeview.vue'
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'
import helpers from '../../helpers'

const store = useStore()
const route = useRoute()
const router = useRouter()
const { name: displayName } = useDisplay()

const library = ref([])
const allVersions = ref([])
const items = ref([])
const loading = ref(false)
const open = ref([])
const show = ref({})
const latest = ref(false)
const calcs = ref([])
const noCalcsError = ref(false)

const libCategories = computed(() => store.state.libCategories)

const getLibCategory = computed(() =>
    items.value.length
        ? libCategories.value[items.value[0].libraryVersionStatusId]
        : ''
)

const mainCols = computed(() => {
    switch (displayName.value) {
        case 'xs':
            return 12
        case 'sm':
            return 12
        case 'md':
            return 12
        case 'lg':
            return 8
    }
    return 7
})

function getLibraryVersion(calc) {
    return allVersions.value.find(
        (vers) => vers.libraryVersionId === calc.libraryVersionId
    )
}

function setOpen(versions) {
    if (route.query.path) {
        let openArr = []
        let routePath = route.query.path
        let parts = routePath.split('-')
        openArr.push(versions[0].id)
        if (parts.length > 1 && parts[1].includes('beta')) {
            parts = parts.splice(1, 1)
        }
        let path = ''
        for (let i = 1; i < parts.length; i++) {
            let libraryName = library.value.name
            if (libraryName.includes(' '))
                libraryName = libraryName.replaceAll(' ', '')
            path += '/' + parts[i]
            let id =
                `n-v${versions[0].libraryVersionId}-${libraryName}${path}`.toLowerCase()
            openArr.push(id)
        }
        open.value = openArr
    }
}

function showRight(calc) {
    show.value = { [calc.calcId]: true }
}

async function setup() {
    loading.value = true
    const libraryId = route.params.libraryId
    library.value = await store.dispatch('getLibrary', libraryId)
    const versions = await store.dispatch('getLibraryVersions', libraryId)
    allVersions.value = versions
    const versionItems = versions.map((v) => helpers.versionToTreeItems(v))
    items.value = versionItems
    calcs.value = versions.flatMap((v) => v.calcs)
    setOpen(versions)
    latest.value = route.query.path === 'latest'
    loading.value = false
}

watch(route, (to) => {
    if (to.name === 'library') setup()
})

onMounted(() => setup())
</script>
